import styled from 'styled-components';
import { TABLET_WIDTH } from 'datastake-daf/src/constants/Style';

export default styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	.test-loc {
		display: flex !important;
		justify-content: space-between;
	}
	.ant-table{
		font-size: 14px;
	}
	div[role="content"]::-webkit-scrollbar {
		display: none;
	}
	div[role="content"] {
		width: ${props => props.isMapToggled ? '100%' : 'calc(100% - 330px)'};
		padding: 30px;
    display: grid;
    grid-template-columns: 100%;
		flex-direction: column;
		justify-content: flex-start;
    justify-content: flex-stat;
		overflow-y: auto;
		max-height: 100%;
    .title.blue {
			color: var(--color-primary-70) !important;
			margin: 40px 0 20px 0;
    }
		.title {
			font-family: SF UI Display;
      font-weight: 500;
			font-size: 18px;
			line-height: 22px;
			color: #001529;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			margin: 0 0 20px 0;
      position: relative;
			span {
				padding-right: 20px;
				background: white;
			}
			span[role="img"] {
				background: white;
				color: #001529;
				padding-right: 0;
				padding-left: 20px;
				cursor: pointer;
			}
			&::after {
				content: '';
				position: absolute;
				width: 100%;
				height: 1px;
				background: #F4F5F8;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				margin: auto;
				z-index: -1;
			}

			@media (${TABLET_WIDTH}) {
				font-size: 17px;
			}
		}
	}
	#map {
		width: 330px;
		position: relative;
		overflow: hidden;
		.title {
			z-index: 500;
			width: 100%;
			top: 0;
			left: 0;
			position: absolute;
			padding: 20px;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center
			h1 {
				font-family: SF UI Display;
				font-style: normal;
				font-weight: 600;
				font-size: 20px;
				line-height: 22px;
				color: #001529;

				@media (${TABLET_WIDTH}) {
					font-size: 19px;
				}
			}
			span[role="img"] {
				font-size: 20px;
				color: #FBB245;
				cursor: pointer;
				vertical-align: 0;

				@media (${TABLET_WIDTH}) {
					font-size: 19px;
				}
			}
		}
		// .leaflet-control-container {
		// 	display: none;
		// }
		.info {
			position: absolute;
			z-index: 500;
			bottom: 0;
			left: 0;
			right: 0;
			margin: auto;
			padding: 15px;
			background: #001529;
			color: #FFFFFF;
			div[role="title"] {
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				align-items: center;
				div {
					display: flex;
					flex-direction: row;
					justify-content: flex-start;
					align-items: center;
				}
				h1 {
					color: white;
					font-size: var(--font-size-lg);
					margin: 0;

					@media (${TABLET_WIDTH}) {
						font-size: 15px;
					}
				}
				img {
					min-width: 50px;
					min-height: 50px;
					max-width: 50px;
					max-height: 50px;
					margin-right: 10px;
				}
				.view-data {
					margin-left: 10px;
					svg {
						width: 30px;
						height:20px
					}
				}
				button {
					display: flex;
    			flex-direction: row;
    			justify-content: center;
					align-items: center;
					border: none;
					color: #001529;
				}
			}
			div[role="content"] {
				display: flex;
				flex-direction: column;
				align-items: start;
				width: 100%;
				padding: 10px 42px;
				> div {
					display: flex;
					flex-direction: row;
					justify-content: flex-start;
					align-items: center;
					color: white;
					line-height: 15px;
					font-size: 12px;
					strong {
						color: #A6ADB4;
						margin-right: 10px;
						font-weight: 500;
					}

					@media (${TABLET_WIDTH}) {
						font-size: 11px;
					}
				}
			}
		}
	}
	.statistic-list {
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding: 15px;
		border-radius: 2px;
		border: 1px solid #E4E7EE;
		box-sizing: border-box;
		border-top: 5px solid #000C17;
		width: calc(100% / 4 - 10px);
		div[role="label"] {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
			span[role="container"] {
				display:flex;
			}
			a {
				color:#A6ADB4;
			}
			a:hover{
				color:#40a9ff;
			}
			span[role="img"] {
				max-width: var(--size-lg);
				max-height: var(--size-lg);
				margin-right: 10px;
				color: #FBB245;
				background: #f9f0da;
				font-size: var(--font-size-lg);
				padding: 4px;
				border-radius: 50%;

				@media (${TABLET_WIDTH}) {
					font-size: 15px;
				}
			}
			h1 {
				font-family: SF UI Display;
				font-style: normal;
				font-weight: 600;
				font-size: var(--font-size-lg);
				line-height: 20px;
				color: #001529;
				margin: 0;

				@media (${TABLET_WIDTH}) {
					font-size: 15px;
				}
			}
		}
		ul {
			margin-top: 15px;
			padding: 0;
			li {
				list-style-type: none;
				position: relative;
				padding-left: var(--size-lg);
				margin-left: 8px;
				&:after {
					content: '';
					position: absolute;
					min-width: 10px;
					min-height: 10px;
					border-radius: 50%;
					left: 0;
					top: 0;
					bottom: 0;
					margin: auto;
					border: 1px solid #3282B8;
				}
			}
		}
	}
	.ant-carousel {
		width: calc(100% - 100px) !important;
	}
	.slick-slide {
		height: 180px;
	}
	.carousel-button {
		height: 180px;
		background: #F4F5F8;
		color: var(--color-primary-70);
		border: none;
  }
	@media screen and (${TABLET_WIDTH}) {
		.statistic-list {
			width: calc(100% / 2 - 10px);
			margin: 0 !important;
			margin-bottom: 20px !important;
		}
	}
  .map-toggle {
		position: absolute;
    z-index: 500;
    background: #6c757d;
    color: white;
    top: 45%;
    padding: 8px 2px;
    border-radius: 5px 0px 0px 5px;
    cursor: pointer;
    writing-mode: vertical-lr;
	}
	.stat-card-2 {
		display: flex;
		flex-direction: column;
		justify-content: center;
		border: 1px solid #E4E7EE;
		border-radius: 3px;
		width: calc(100% / 4 - 10px);
		align-items: center;
    h2 {
      font-size: 15px;
      color: #525F6C;
      line-height: 22px;
			margin: 0;
			margin-top: 12px;
    }
	}
  .project-info {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    padding: 12px;
    border-radius: 3px;
    background: rgba(0, 0, 0, 0.03);
    margin-bottom: 20px;
    p {
      margin: 0;
      strong {
        font-weight: 800;
        color: black;
      }
    }
  }
  .list-card {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: var(--size);
    border: 1px solid #E4E7EE;
    border-radius: 3px;
    .head {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      margin-bottom: var(--size);
      span[role="img"] {
        color: black;
        margin-top: 2px;
        svg {
          margin: auto 12px auto 0;
        }
      }
      h3 {
        font-size: 18px;
      }
    }
    ul {
      margin: 0;
      padding: 0;
      list-style-type: none;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      li {
        padding: 8px 0;
        border-bottom: 1px solid #E4E7EE;
        span[role="img"] {
          color: #FBB245;
          margin-right: 8px;
          svg {
            margin-top: -8px;
          }
        }
        strong {
          font-weight: 900;
          color: black;
        }
      }
    }
  }
`;
